import MaintenancePage from "./MaintenancePage";

const ACCESS_KEY = "special_access";

const hasSpecialAccess = (maintenanceData) => {
    try {
        const raw = localStorage.getItem(ACCESS_KEY);
        if (!raw) return false;

        const { email, code } = JSON.parse(raw);

        return maintenanceData.acces_permission.some(
            (p) =>
                p.user_email === email &&
                p.acces_code === code
        );
    } catch {
        return false;
    }
};

export const MaintenanceGuard = ({ maintenanceData, children }) => {

    const accessGranted =
        typeof window !== "undefined" &&
        hasSpecialAccess(maintenanceData);

    if (maintenanceData.enabled && !accessGranted) {
        return <MaintenancePage />;
    }

    return children;
};
